<script lang="ts">
	import Link from "../Link.svelte";
	import cake from "../../../../core/assets/icons/cake.svg?raw";
	import "@glidejs/glide/dist/css/glide.core.min.css";
	import cake1ImgSm from "../../assets/images/custom-cakes/banner/cake-1.jpg?w=400&webp&imagetools";
	import cake1ImgMd from "../../assets/images/custom-cakes/banner/cake-1.jpg?w=432&webp&imagetools";
	import cake1ImgLg from "../../assets/images/custom-cakes/banner/cake-1.jpg?w=496&webp&imagetools";
	import cake2ImgSm from "../../assets/images/custom-cakes/banner/cake-2.jpg?w=400&webp&imagetools";
	import cake2ImgMd from "../../assets/images/custom-cakes/banner/cake-2.jpg?w=432&webp&imagetools";
	import cake2ImgLg from "../../assets/images/custom-cakes/banner/cake-2.jpg?w=496&webp&imagetools";
	import cake3ImgSm from "../../assets/images/custom-cakes/banner/cake-3.jpg?w=400&webp&imagetools";
	import cake3ImgMd from "../../assets/images/custom-cakes/banner/cake-3.jpg?w=432&webp&imagetools";
	import cake3ImgLg from "../../assets/images/custom-cakes/banner/cake-3.jpg?w=496&webp&imagetools";
	import cake4ImgSm from "../../assets/images/custom-cakes/banner/cake-4.jpg?w=400&webp&imagetools";
	import cake4ImgMd from "../../assets/images/custom-cakes/banner/cake-4.jpg?w=432&webp&imagetools";
	import cake4ImgLg from "../../assets/images/custom-cakes/banner/cake-4.jpg?w=496&webp&imagetools";
	import cake5ImgSm from "../../assets/images/custom-cakes/banner/cake-5.jpg?w=400&webp&imagetools";
	import cake5ImgMd from "../../assets/images/custom-cakes/banner/cake-5.jpg?w=432&webp&imagetools";
	import cake5ImgLg from "../../assets/images/custom-cakes/banner/cake-5.jpg?w=496&webp&imagetools";
	import cake6ImgSm from "../../assets/images/custom-cakes/banner/cake-6.jpg?w=400&webp&imagetools";
	import cake6ImgMd from "../../assets/images/custom-cakes/banner/cake-6.jpg?w=432&webp&imagetools";
	import cake6ImgLg from "../../assets/images/custom-cakes/banner/cake-6.jpg?w=496&webp&imagetools";
	import cake7ImgSm from "../../assets/images/custom-cakes/banner/cake-7.jpg?w=400&webp&imagetools";
	import cake7ImgMd from "../../assets/images/custom-cakes/banner/cake-7.jpg?w=432&webp&imagetools";
	import cake7ImgLg from "../../assets/images/custom-cakes/banner/cake-7.jpg?w=496&webp&imagetools";
	import cake8ImgSm from "../../assets/images/custom-cakes/banner/cake-8.jpg?w=400&webp&imagetools";
	import cake8ImgMd from "../../assets/images/custom-cakes/banner/cake-8.jpg?w=432&webp&imagetools";
	import cake8ImgLg from "../../assets/images/custom-cakes/banner/cake-8.jpg?w=496&webp&imagetools";
	import cake9ImgSm from "../../assets/images/custom-cakes/banner/cake-9.jpg?w=400&webp&imagetools";
	import cake9ImgMd from "../../assets/images/custom-cakes/banner/cake-9.jpg?w=432&webp&imagetools";
	import cake9ImgLg from "../../assets/images/custom-cakes/banner/cake-9.jpg?w=496&webp&imagetools";
	import cake10ImgLg from "../../assets/images/custom-cakes/banner/cake-10.jpg?w=496&webp&imagetools";
	import cake10ImgSm from "../../assets/images/custom-cakes/banner/cake-10.jpg?w=400&webp&imagetools";
	import cake10ImgMd from "../../assets/images/custom-cakes/banner/cake-10.jpg?w=432&webp&imagetools";
	import { getGlobalSettings } from "../../getGlobalSettings.js";
	import { nbspify } from "../../../../core/utils/nbspify";
	import Glider from "../Glider.svelte";
	import type { ImageSizes } from "../../../../core/schema/Image";
	import { customCakesEnquiryPathMap, customCakesPathMap } from "../../../../core/schema/paths/customCakesPathMap";

	export let buttonText = "Zjistit dostupnost termínu";
	export let border = false;

	const { TENANT_LOCALE } = getGlobalSettings();

	const urlSlug = `/${customCakesPathMap[TENANT_LOCALE]}#${customCakesEnquiryPathMap[TENANT_LOCALE]}`;

	const images: ImageSizes[] = [
		{
			sm: cake1ImgSm,
			md: cake1ImgMd,
			lg: cake1ImgLg,
		},
		{
			sm: cake2ImgSm,
			md: cake2ImgMd,
			lg: cake2ImgLg,
		},
		{
			sm: cake3ImgSm,
			md: cake3ImgMd,
			lg: cake3ImgLg,
		},
		{
			sm: cake4ImgSm,
			md: cake4ImgMd,
			lg: cake4ImgLg,
		},
		{
			sm: cake5ImgSm,
			md: cake5ImgMd,
			lg: cake5ImgLg,
		},
		{
			sm: cake6ImgSm,
			md: cake6ImgMd,
			lg: cake6ImgLg,
		},
		{
			sm: cake7ImgSm,
			md: cake7ImgMd,
			lg: cake7ImgLg,
		},
		{
			sm: cake8ImgSm,
			md: cake8ImgMd,
			lg: cake8ImgLg,
		},
		{
			sm: cake9ImgSm,
			md: cake9ImgMd,
			lg: cake9ImgLg,
		},
		{
			sm: cake10ImgSm,
			md: cake10ImgMd,
			lg: cake10ImgLg,
		},
	];
</script>

<div
	class="border-secondary-200 flex flex-col items-center gap-10 overflow-hidden rounded-3xl px-6 py-8 min-[400px]:gap-16 sm:px-10 sm:py-12 md:px-14 md:py-16 lg:flex-row lg:gap-16 lg:p-10 lg:pl-16 lg:pr-10 xl:pl-20 xl:pr-4"
	class:border
>
	<div class="flex flex-col justify-center text-center lg:basis-[calc(50%-1.5rem)] lg:justify-start lg:text-left">
		<h2 class="decorative-headline !mx-0 !mb-6 lg:!text-left">Speciální dorty</h2>
		<p class="h2 mb-8 !text-lg lg:!text-xl xl:!text-2xl">
			{nbspify("Narozeninové a firemní dorty podle vašich představ")}
		</p>
		<p class="mb-10">
			{nbspify(
				"Náš narozeninový dort povýší každou vaši oslavu na nezapomenutelný zážitek. Může být barevný s mnoha ozdobami nebo minimalisticky bílý s jemným zdobením. Dort od nás se hodí jak na dětskou oslavu, tak k oslavě životního jubilea a nebo jako šperk vaší firemní oslavy.",
			)}
		</p>
		<Link
			class="sm:!text-md mx-auto !rounded-full !px-8 !py-2 sm:!px-12 sm:!py-4 lg:mx-0 xl:!px-14 xl:!py-[1.125rem] xl:!text-[1.375rem]"
			href={urlSlug}
			asButton
			variant="primary"
			icon={cake}
			iconClass="w-6"
		>
			{buttonText}
		</Link>
	</div>
	<Glider firstImageLoading="eager" {images} />
</div>
